import '.bs{position:relative;}.ssr-plugin'
import '.a2{width:100%;}.ssr-plugin'
import '.ga{min-height:200px;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.n{justify-content:center;}.ssr-plugin'
import '.bv{align-items:flex-start;}.ssr-plugin'
import '.t{padding:2rem;}.ssr-plugin'
import '.cn{background:var(--shades-white);}.ssr-plugin'
import '.m{overflow:hidden;}.ssr-plugin'
import '.i{position:absolute;}.ssr-plugin'
import '.if{top:50%;}.ssr-plugin'
import '.ig{right:1rem;}.ssr-plugin'
import '.ih{transform:translateY(-50%);}.ssr-plugin'
import '.ii{width:120px;}.ssr-plugin'
import '.ij{height:120px;}.ssr-plugin'
import '.ik{z-index:0;}.ssr-plugin'
import '.c{align-items:center;}.ssr-plugin'
import '.hs{z-index:1;}.ssr-plugin'
import '.ap{gap:0.5rem;}.ssr-plugin'
import '.il{max-width:calc(100% - 140px);}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { Text } from '@app/components/core/typography/Text'
import { Image } from '@app/components/core/image/Image'

export interface StatisticProps {
  number: string
  subtitle: string
  illustration?: string
  style?: Style
}

export const Statistic = ({
  number,
  subtitle,
  illustration,
  style,
}: StatisticProps) => {
  return (
    <styled.div className="bs a2 ga a b n bv t cn m"
      data-testid="statistic"
      style={{
        ...style,
      }}
    >
      {/* Background Illustration - Right Aligned */}
      {illustration && (
        <div className="i if ig ih ii ij ik a c n"
        >
          <Image
            src={illustration}
            alt={`${subtitle} illustration`}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
            }}
          />
        </div>
      )}

      {/* Content - Left Aligned with higher z-index */}
      <div className="bs hs a b bv ap il"
      >
        {/* Bold Number */}
        <Title.H1
          style={{
            fontSize: '4rem',
            fontWeight: '700',
            lineHeight: '100%',
            margin: 0,
            color: 'var(--primary-blue)',
            fontFamily: 'FunnelDisplay',
          }}
        >
          {number}
        </Title.H1>

        {/* Subtitle */}
        <Text.Medium
          style={{
            color: 'var(--primary-blue)',
            opacity: 0.8,
            margin: 0,
            lineHeight: '140%',
            fontWeight: '400',
          }}
        >
          {subtitle}
        </Text.Medium>
      </div>
    </styled.div>
  )
}
